import { render } from "./TheAposContextTitle.vue?vue&type=template&id=18e1fddd&scoped=true"
import script from "./TheAposContextTitle.vue?vue&type=script&lang=js"
export * from "./TheAposContextTitle.vue?vue&type=script&lang=js"

import "./TheAposContextTitle.vue?vue&type=style&index=0&id=18e1fddd&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e1fddd"],['__file',"admin-bar/ui/apos/components/TheAposContextTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18e1fddd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18e1fddd', __exports__)) {
    api.reload('18e1fddd', __exports__)
  }
  
  module.hot.accept("./TheAposContextTitle.vue?vue&type=template&id=18e1fddd&scoped=true", () => {
    api.rerender('18e1fddd', render)
  })

}


export default __exports__